'use strict';

const EmbeddedValue = require('../rlink-data-connector/storage/EmbeddedValue');
const reference = require('../rlink-data-connector/reference');
const container = require('../rlink-data-connector/container');
const BasicData = require('../rlink-data-connector/BasicData');
const isSubclassOf = require('../rlink-type-utils/isSubclassOf');
const Request = require('../rlink-data-connector/Request');

/**
 * Returns an embedded value for the given StoragePayload and reference.
 *
 * For DataReferences where typeOrRequest is a BasicData, the storage payload
 * is also wrapped inside a ConstructableContainer first.
 *
 * @param  {(Request|BasicData)} typeOrRequest
 * @param  {(String|Array)} idOrRequestArgs
 * @param  {StoragePayload} storagePayload
 * @param  {Object} meta
 * @return {EmbeddedValue}
 */
module.exports = function embedded (typeOrRequest, idOrRequestArgs, storagePayload, meta = {} ) {
  let value = storagePayload;
  if (isSubclassOf(typeOrRequest, BasicData)) {
    value = container(typeOrRequest, idOrRequestArgs, storagePayload);
  }

  let ref = (typeOrRequest instanceof Request)
    ? reference(typeOrRequest, ...idOrRequestArgs)
    : reference(typeOrRequest, idOrRequestArgs);

  return new EmbeddedValue(ref, value, meta);
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/embedded.js